import { ChangeDetectionStrategy, Component } from "@angular/core";
import { LookerRiskDashboardType } from "../../looker-risk-dashboard-type.enum";
import { HideFilters } from "../../models/analytics-hide-filters.enum";

@Component({
  selector: "app-clinical-aging-dw",
  templateUrl: "./clinical-aging-dw.component.html",
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ClinicalAgingDwComponent {

  filters: string[] = ["Projects"];
  dashboardType = LookerRiskDashboardType.CLINICAL_AGING_REPORT_DW;
  hideFilters: string[] = [HideFilters.PROJECT_ID, HideFilters.USER_ID, HideFilters.ORG_ID];
}
